import * as React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Create, FormManager, FormRow, PageTitle, selectUser, useCloneEntity, UserState } from 'gossamer-front-end';
import { Entity, getListRowLink } from 'gossamer-unified';
import { FeedbackForm, FeedbackFormRow } from 'cb-model';
import { useFormikContext } from 'formik';
import { CustomInfo } from 'cb-unified';

export const FeedbackFormCreate = (): React.JSX.Element => {
  const navigate = useNavigate();
  const user = useSelector((state: { user: UserState }) => selectUser(state));
  const LocalFeedbackForm = useCloneEntity(FeedbackForm);
  const override: Partial<FeedbackFormRow> = {};
  if ((user.customInfo as CustomInfo)?.adminInstitutionId) {
    override.institution_id = (user.customInfo as CustomInfo)?.adminInstitutionId;
  }

  return (
    <>
      <PageTitle verb="Create" entity={LocalFeedbackForm} />
      <FormManager
        compoundUrl="/main/~/feedback-form-create"
        handleCancel={() => navigate(`/admin/feedback-form/search`)}
        handleSuccess={({ keyOfFirstCreate }) =>
          navigate(getListRowLink(LocalFeedbackForm.listRowLink, keyOfFirstCreate))
        }
        initialization={{
          main: { type: 'create-single', entity: LocalFeedbackForm, override },
        }}
      >
        <FeedbackFormLogic entity={LocalFeedbackForm} />
        <Create valuesKey="main" entity={LocalFeedbackForm} />
      </FormManager>
    </>
  );
};

interface FeedbackFormLogicProps {
  entity: Entity<FeedbackFormRow>;
}

export const FeedbackFormLogic = (props: FeedbackFormLogicProps): React.JSX.Element => {
  const { values } = useFormikContext<{ main: FormRow<FeedbackFormRow> }>();
  console.log('inside FeedbackFormLogic', values.main.internal_external_mode);
  props.entity.fields.external_form_url.visible = values.main.internal_external_mode !== 'internal';
  return null;
};
